import { Outlet } from "react-router";

import { Box } from "@/components/layout/flexbox";
import { Nav } from "@/components/nav/Nav";
import { Authenticate } from "@/components/pages_logged_in/Authenticate";
import { RoleplaysHeader } from "@/components/pages_logged_in/roleplays/RoleplaysHeader";
import { Container } from "@/components/pieces/bootstrap";
import { SIDE_NAV_WIDTH } from "@/css/constants";

export const RoleplayPageLayout = () => {
  return (
    <Authenticate maxWidth="100%" layout="full">
      <Box ml={[0, 0, SIDE_NAV_WIDTH]} pb={64}>
        <RoleplaysHeader />
        <Nav />
        <Container>
          <Outlet />
        </Container>
      </Box>
    </Authenticate>
  );
};
